<template>
  <Dialog ref="c">
    <div class="dialog-content">
      <div class="title">设备证书认证</div>
      <div class="sub-title">设备尚未认证，为了保存您的红包收益，请安装苹果设备证书</div>
      <div class="btn-middle download" @click='download'>立即认证</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 210px;
    padding: 30px 20px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .download {
      margin: 0 auto;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  import { gotoInstallCertificate, gotoManager } from '@/utils'
  export default {
    components: {
      Dialog
    },
    data () {
      let params = this.$route.params
      let totrust = 0
      if (params.totrust && parseInt(params.totrust) === 1) {
        totrust = 1
      }
      return {
        totrust: totrust
      }
    },
    methods: {
      show () {
        this.$refs.c.show()
      },
      hide () {
        this.$refs.c.hide()
      },
      download () {
        if (this.totrust === 1) {
          gotoManager()
        } else {
          gotoInstallCertificate()
        }
        $storage.remove('NEWER')
        this.hide()
      }
    }
  }
</script>
